// Module
var code = `<!-- ko foreach: model.actions -->
<!-- ko component: { name: 'svc-tab-button', params: { model: \$data } } -->
<!-- /ko -->
<!-- /ko -->`;
// Exports
export default code;